module.exports = __webpack_public_path__ + "img/5.44ab47bd.png";